import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'react-overlay-loader/lib/Loader';
import { DepositFilterTypes } from '../../../../../../utils/constants/deposits';
import '../index.scss';
import UsersTableHead from './UsersTableHead';
import UsersTableRow from './UsersTableRow';

class UsersTable extends React.Component {
  render() {
    const {
      venue,
      bookingList,
      showBookingModal,
      searchResults,
      searchValue,
      showBookingDetailsModal,
      loading,
    } = this.props;
    let filteredBookingList = bookingList;

    if (searchResults && searchResults.length > 0 && searchValue) {
      filteredBookingList = searchResults;
    } else {
      if (searchResults.length === 0 && searchValue) {
        return (
          <div>
            <Table>
              <UsersTableHead venue={venue} />
              <TableBody />
            </Table>
            <div
              style={{
                padding: '5px',
              }}
            >
              <p style={{ textAlign: 'center' }}>No users found.</p>
              <Loader loading={loading} />
            </div>
          </div>
        );
      }
    }

    return (
      <div>
        <Table>
          <UsersTableHead venue={venue} />
          <TableBody>
            {filteredBookingList.map(booking => {
              const boundBookingModal = showBookingModal.bind(this, booking);
              return (
                <UsersTableRow
                  showBookingDetailsModal={showBookingDetailsModal}
                  onClick={boundBookingModal}
                  key={booking.id}
                  venue={venue}
                  booking={booking}
                />
              );
            })}
          </TableBody>
        </Table>
        <Loader loading={loading} />
      </div>
    );
  }
}

UsersTable.propTypes = {
  showBookingModal: PropTypes.func.isRequired,
  venue: PropTypes.object.isRequired,
  bookingList: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  showBookingDetailsModal: PropTypes.func.isRequired,
  filterType: PropTypes.oneOf(Object.values(DepositFilterTypes)).isRequired,
  searchResults: PropTypes.array,
  searchValue: PropTypes.string,
};

export default UsersTable;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Users/ViewUsersPanel/UsersTable/index.jsx